/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS103: Rewrite code to no longer use __guard__
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
/* eslint no-shadow:0, eqeqeq:0, no-use-before-define:0 */
let SocketRPC;
const Auth = require('app/scripts/db/auth');
const Backbone = require('app/scripts/lib/backbone');
const Monitor = require('app/scripts/lib/monitor');
const Socket = require('app/scripts/network/socket');
const { Storage } = require('@trello/storage');
const Util = require('app/scripts/lib/util');
const _ = require('underscore');
const log = require('app/scripts/debug/log');
const { track } = require('@trello/analytics');
const { featureFlagClient } = require('@trello/feature-flag-client');

module.exports = SocketRPC = (function() {
  SocketRPC = class SocketRPC {
    static initClass() {
      _.extend(this.prototype, Backbone.Events);
    }

    constructor(delegate) {
      let sEv;
      this.delegate = delegate;
      this.reqid = 0;
      this.dictCallback = {};
      this.dictTime = {};
      this.connectedOnce = false;
      this.modelIxUpdate = {};

      this.hasSockets =
        'WebSocket' in window && Storage.get('useWebsockets') !== 'no';

      if (!('WebSocket' in window)) {
        track('RPC', 'No Sockets', 'No WebSocket');
      } else if (Storage.get('useWebsockets') === 'no') {
        track('RPC', 'No Sockets', 'pitStop');
      }

      if (!this.hasSockets) {
        return;
      }

      log('rpc', 'opening newSocket');
      const protocol = document.location.protocol === 'http:' ? 'ws:' : 'wss:';
      this.socket = new Socket(
        `${protocol}//${
          document.location.host
        }/1/Session/socket?token=${Auth.myToken()}`,
        {
          maxReconnectDelay: 64000,
          failedConsecutiveReconnectsLimit: 10,
          reconnectRateLimit: 3,
          reconnectRateWindow: Util.getMs({ minutes: 5 }),
          maxReconnectsPerDay: 100,
          fxReconnectDelay(event) {
            const status = Monitor.getStatus();
            const slowMs =
              status === 'active'
                ? Util.randomWait(
                    Util.getMs({ seconds: 10 }),
                    Util.getMs({ seconds: 30 }),
                  )
                : Util.randomWait(
                    Util.getMs({ seconds: 30 }),
                    Util.getMs({ minutes: 2 }),
                  );
            const fastMs =
              status === 'active'
                ? Util.randomWait(100, Util.getMs({ seconds: 1 }))
                : Util.randomWait(
                    Util.getMs({ seconds: 2 }),
                    Util.getMs({ seconds: 10 }),
                  );

            if (event == null || event.code === 1006) {
              // We caused the disconnection or a hard crash of the proc, respectively
              // Let's take it slow
              return slowMs;
            } else if (event.code === 4000) {
              let seconds;
              try {
                seconds = parseInt(event.reason, 0);
              } catch (error) {
                fastMs;
              }
              if (status === 'active') {
                return Util.randomWait(
                  Util.getMs({ seconds }),
                  Util.getMs({ seconds }) * 4,
                );
              } else {
                return Util.randomWait(
                  Util.getMs({ seconds }) * 4,
                  Util.getMs({ seconds }) * 4 * 4,
                );
              }
            } else {
              return fastMs;
            }
          },
        },
      );

      for (sEv of [
        'connect',
        'reconnect',
        'connecting',
        'reconnecting',
        'disconnect',
        'connect_failed',
        'reconnect_failed',
        'error',
      ]) {
        ((sEv) => {
          return this.socket.on(sEv, (info) => {
            return log('rpc', 'socket event', sEv, info);
          });
        })(sEv);
      }

      for (sEv of ['connecting', 'reconnecting']) {
        ((sEv) => {
          return this.socket.on(sEv, () => {
            log('rpc', 'connecting');
            return this.trigger('connecting');
          });
        })(sEv);
      }

      this.socket.on('connect_failed', () => {
        log('rpc', 'connect_failed');
        return this.trigger('connect_failed');
      });

      this.socket.on('reconnect_failed', () => {
        log('rpc', 'reconnect_failed');
        this.trigger('reconnect_failed');

        if (
          this.socket.reconnectNotAttemptedReason === this.socket.previousReason
        ) {
          return;
        }

        const timeSinceGoodConnection =
          Date.now() - (this.dateLastMessage || 0);
        track(
          'Error',
          'Websocket Redbox',
          'Time since good connection',
          undefined,
          timeSinceGoodConnection,
        );
        track(
          'Error',
          'Websocket Redbox',
          'Reconnect failure reason',
          this.socket.reconnectNotAttemptedReason,
          undefined,
        );

        log('rpc', 'time since last good connection', timeSinceGoodConnection);
        return log(
          'rpc',
          'reconnect failure reason',
          this.socket.reconnectNotAttemptedReason,
        );
      });

      this.socket.on('connect', () => {
        log('rpc', 'connect');
        this.trigger('connect');
        if (this.connectedOnce === false) {
          track(
            'RPC',
            'connect',
            'Time since load in milliseconds',
            Math.round(performance.now()),
          );
        }
        return (this.connectedOnce = true);
      });

      this.socket.on('reconnect', () => {
        log('rpc', 'reconnect');
        clearTimeout(this.timeoutInvokeResponse);
        delete this.timeoutInvokeResponse;
        return this.trigger('reconnect');
      });

      this.socket.on('disconnect', (reason) => {
        log('rpc', 'disconnect', reason);
        clearTimeout(this.timeoutInvokeResponse);
        delete this.timeoutInvokeResponse;
        _.each(this.dictCallback, (next) =>
          typeof next === 'function' ? next('disconnected') : undefined,
        );
        this.dictCallback = {};
        return (this.dictTime = {});
      });

      this.socket.on('error', () => {
        if (
          this.connectedOnce &&
          !__guard__(
            this.socket != null ? this.socket.socket : undefined,
            (x) => x.connected,
          )
        ) {
          return this.trigger('disconnect');
        }
      });

      this.socket.on('data', (msg) => {
        return this._messageHandler(msg);
      });
    }

    _messageHandler(msg) {
      let next;
      this.dateLastMessage = Date.now();
      log('rpc', 'message', msg);

      //For timeout clear, we don't really care if it's the same one, just that the server is alive
      clearTimeout(this.timeoutInvokeResponse);
      delete this.timeoutInvokeResponse;

      if (msg.reqid != null) {
        next = this.dictCallback[`fx${msg.reqid}`];
      }

      if (msg.result != null) {
        if (typeof next === 'function') {
          next(null, msg.result);
        }
      } else if (msg.notify != null ? msg.notify.event : undefined) {
        if (msg.idModelChannel != null) {
          this.delegate.setIxLastUpdate(
            msg.idModelChannel,
            msg.ixLastUpdateChannel,
          );
        }
        this.trigger(
          msg.notify.event,
          _.extend({ idModelChannel: msg.idModelChannel }, msg.notify),
        );
      } else if (msg.error) {
        if (typeof next === 'function') {
          next(msg.error);
        }
      } else {
        log('rpc', 'unrecognized message', msg);
      }

      if (msg.reqid != null) {
        const delta = new Date() - this.dictTime[msg.reqid];
        log('timing', 'message', msg.reqid, 'time', delta);

        delete this.dictCallback[`fx${msg.reqid}`];
        delete this.dictTime[msg.reqid];
      }
    }

    subscribe(modelType, idModel, tags, next) {
      return this.send(
        {
          type: 'subscribe',
          modelType,
          idModel,
          tags,
          invitationTokens: Util.invitationTokens(),
        },
        (err, ixLastUpdate) => {
          if (err != null) {
            log('rpc', err);
          } else {
            this.delegate.setIxLastUpdate(idModel, ixLastUpdate);
          }
          return typeof next === 'function'
            ? next(err, ixLastUpdate)
            : undefined;
        },
      );
    }

    unsubscribe(modelType, idModel, next) {
      return this.send(
        {
          type: 'unsubscribe',
          modelType,
          idModel,
        },
        (err, response) => {
          if (err != null) {
            log('rpc', err);
          }
          return typeof next === 'function' ? next(err, response) : undefined;
        },
      );
    }

    ping(next) {
      // We need a way to test ping failure in order to verify that polling works in the event that the client supports
      // WebSockets, but fails to establish a connection before the timeout.
      if (featureFlagClient.get('force-websocket-ping-failure', false)) {
        return typeof next === 'function'
          ? next(new Error('Forcing ping failure'), {}, this)
          : undefined;
      } else {
        return this.send(
          {
            type: 'ping',
          },
          (err, response) => {
            if (err != null) {
              log('rpc', err);
            }
            return typeof next === 'function'
              ? next(err, response, this)
              : undefined;
          },
        );
      }
    }

    _getSubscriptions() {
      // For debugging - thus logging only
      return this.send(
        {
          type: 'getSubscriptions',
        },
        (err, response) => {
          if (response != null) {
            return log('rpc', response);
          }
        },
      );
    }

    send(msg, next) {
      this.dictCallback[`fx${this.reqid}`] = next;
      this.dictTime[this.reqid] = new Date();
      msg.reqid = this.reqid++;

      const sMsg = JSON.stringify(msg);

      log('rpc', 'invoke: ' + sMsg);
      this.socket.send(sMsg);
      if (this.timeoutInvokeResponse == null) {
        this.timeoutInvokeResponse = setTimeout(() => {
          if (this.socket.state !== Socket.CONNECTED) {
            // The socket knows it isn't connected.
            return;
          }
          log(
            'rpc',
            'No response from the socket.io server in 10 seconds. Disconnecting.',
          );
          clearTimeout(this.timeoutInvokeResponse);
          delete this.timeoutInvokeResponse;
          return this.socket != null ? this.socket.disconnect() : undefined;
        }, 10000);
      }
    }

    resync(...idModels) {
      if (_.isEmpty(idModels)) {
        idModels = null;
      }
      return this.delegate.rpcAJAX.doPoll(idModels, this, function() {});
    }

    disconnect() {
      log('rpc', 'disconnecting');
      this.socket.disconnect();
    }

    destroy() {
      return this.socket.destroy();
    }

    hasSocketTransport() {
      return this.hasSockets;
    }
  };
  SocketRPC.initClass();
  return SocketRPC;
})();

function __guard__(value, transform) {
  return typeof value !== 'undefined' && value !== null
    ? transform(value)
    : undefined;
}
